import { useState, useEffect, useMemo } from 'react';
import { Button, Modal } from '@bfe/moly';
import cls from 'classnames';
import { useFm, useParams } from '@web3/base-hooks';
import { appPath } from '@web3/base-utils';
import { scTrack, WEB3_EVENT } from '@web3/base-tracking';

import styles from './index.module.scss';

interface Props {
  eligibilityCount: number;
}

const animationCellList = new Array(9).fill(1);

export const RewardModal = (props: Props) => {
  const { eligibilityCount } = props;

  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowAnimation, setIsShowAnimation] = useState(false);
  const fm = useFm();
  const { locale } = useParams();

  const toRewards = () => {
    scTrack(WEB3_EVENT.Web3UserClick, {
      page_name: 'AirdropArcade_Homepage',
      button_name: 'ClaimRewards',
    });
    window.location.href = `${window.location.origin}/${locale}${appPath}/rewards`;
  };

  useEffect(() => {
    if (!eligibilityCount) return;

    setIsShowAnimation(true);
    setTimeout(() => {
      setIsShowAnimation(false);
      setIsShowModal(true);
    }, 3000);
  }, [eligibilityCount]);

  return (
    <>
      <Modal
        open={isShowModal}
        title={false}
        footer={null}
        size="small"
        onClose={() => {
          setIsShowModal(false);
        }}
      >
        <div className={styles.content}>
          <img
            className={styles.img}
            src={`${appPath}/images/home/claim-reward2.png`}
          />
          <div className={styles.title}>{fm('congrats')}</div>
          <div className={styles.desc}>
            {fm('airdropsToClaim', {
              num: eligibilityCount,
            })}
          </div>
        </div>
        <Button
          className={cls('mt-6 w-full')}
          variant="primary"
          size="middle"
          onClick={toRewards}
        >
          {fm('claimNow')}
        </Button>
      </Modal>
      {isShowAnimation && (
        <div className={styles.bg}>
          {animationCellList.map((item, index) => {
            return (
              <img
                className={styles.animationCell}
                style={{
                  left: `${(index + 1) * 10}%`,
                  animationDelay: `${Math.random() * 2}s`,
                }}
                key={index}
                src={`${appPath}/images/home/claim-reward2.png`}
              />
            );
          })}
          <div></div>
        </div>
      )}
    </>
  );
};
